<div class="row no-gutters mb-3">
    <button id="{{idPrefix}}btn.create"
            mat-flat-button
            color="accent"
            class="full-width"
            (click)="panelOpen = true"
            [disabled]="panelOpen">
        {{ createBtnLabel | translate | uppercase }}
    </button>
</div>

<mat-card class="mt-3" *ngIf="panelOpen">
    <mat-card-content>

        <div class="row no-gutters">
            <div class="col-sm-12">
                <mat-form-field class="full-width">
                    <mat-label>{{ nameLabel | translate }}</mat-label>
                    <input id="{{idPrefix}}name"
                           type="text" matInput
                           [formControl]="name"
                           required>
                    <mat-error *ngIf="name.hasError('required')">{{ 'common.error.required_field' | translate }}</mat-error>
                    <ng-container *ngFor="let errorLabel of errorLabels">
                        <mat-error *ngIf="name.hasError(errorLabel.error)">{{ errorLabel.label | translate }}</mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-sm-6">
                <button id="{{idPrefix}}btn.save"
                        mat-flat-button color="accent" class="w-100"
                        (click)="submit()"
                        [disabled]="name.invalid">{{ 'common.btn.save' | translate }}
                </button>
            </div>
            <div class="col-sm-6">
                <a id="{{idPrefix}}btn.cancel"
                   mat-stroked-button
                   color="primary"
                   class="w-100"
                   (click)="cancel()">
                    {{ 'common.btn.cancel' | translate }}
                </a>
            </div>
        </div>

    </mat-card-content>
</mat-card>
